<script setup lang="ts" generic="T extends string[]">
const model = defineModel<T>();

const props = withDefaults(
  defineProps<{
    field: string;
    options: T[];
    max?: number;
    required?: boolean;
  }>(),
  {
    options: () => [],
  },
);

function updateModel(value: string, browserEvent: Event) {
  const currentValue = (model.value as string[]) || [];
  if (currentValue.includes(value)) {
    if (currentValue.length === 1) {
      (browserEvent.target as HTMLInputElement).checked = true;
    } else {
      model.value = currentValue.filter((v) => v !== value) as T extends true
        ? string[]
        : string;
    }
  } else {
    const newValue = [...currentValue, value] as T extends true
      ? string[]
      : string;
    if (
      newValue instanceof Array &&
      props.max !== undefined &&
      newValue.length > props.max
    ) {
      return;
    }
    model.value = (() => {
      if (
        currentValue.includes("none") &&
        newValue.includes("none") &&
        currentValue.length !== newValue.length
      ) {
        return newValue.filter((v) => v !== "none");
      }
      if (!currentValue.includes("none") && newValue.includes("none")) {
        return newValue.filter((v) => v === "none");
      }
      return newValue;
    })();
  }
}
</script>

<template>
  <div class="flex w-full flex-row flex-wrap gap-1">
    <template v-for="option in options" :key="option.value">
      <label
        :aria-checked="((model as string[]) ?? []).includes(option.value)"
        :aria-disabled="
          max !== undefined &&
          model.length >= max &&
          !model.includes(option.value)
        "
        class="bg-background-inactive border-stroke-inactive text-text-soft aria-checked:bg-background-active aria-checked:border-stroke-active aria-disabled:text-text-inactive relative flex cursor-pointer items-center justify-center overflow-hidden whitespace-nowrap rounded-[6px] border px-[14px] py-2 text-xs font-normal leading-none aria-checked:text-white/80 aria-disabled:cursor-not-allowed"
      >
        <input
          class="absolute left-[-9999px] opacity-0"
          type="checkbox"
          :name="field"
          :value="option.value"
          :checked="((model as string[]) ?? []).includes(option.value)"
          :disabled="
            (max !== undefined &&
              model.length >= max &&
              !model.includes(option.value)) ||
            option.required
          "
          @change="updateModel(option.value, $event)"
        />
        {{ $t(`DrillConfig.label.${option.title}`) }}
      </label>
    </template>
  </div>
</template>
